import ui from '@bmp-vue/core/api/ui'
import enums from '../controllers/enums'
import Vue from 'vue'
import Conf from '../components/dbs/Confirmacao'

export default {
  CustomPostAction: (response) => {
    ui.HideLoading()
    const tipoResponse = enums.TipoResponseContextoCadastros

    if (response.tipoMensagem === tipoResponse.Alerta) {
      ui.ShowAlert(response.titulo || 'Atenção', response.mensagem || '')
      return true
    }

    if (response.tipoMensagem === tipoResponse.Sucesso) {
      ui.ShowSuccess(response.titulo || 'Sucesso', response.mensagem || 'Operação Realizada com Sucesso!')
      return true
    }

    ui.ShowError(response.titulo || 'Erro', response.mensagem || 'Ocorreu um erro na requisição')
    return false
  },
  CustomConfirmacao: function (tipo, mensagem, callbackSim, callbackNao, titulo, sim, nao) {
    const vuetify = require('@bmp-vue/core/plugins/vuetify').default
    const componentInstance = new Vue({
      ...Conf,
      propsData: {
        tipo: tipo,
        titulo: titulo,
        mensagem: mensagem,
        sim: sim,
        nao: nao,
        callbackSim: callbackSim,
        callbackNao: callbackNao
      },
      vuetify
    })
    componentInstance.$mount()
  },
}
